
import React from 'react'

import { components } from "react-select";

// components
import {
  CInputGroup,
  CCol,
  CDropdown,
  CFormLabel,
  CFormInput
} from '@coreui/react-pro'
import FormSelectInput from './FormSelectInput'

const FormPhoneNumber = ({
  colSize,
  className,
  inputLabel,
  placeholder,
  country,
  countryOptions,
  value,
  handlePhoneNumber,
  handlePhoneCountry,
  errors,
  disabled = false,
  colSizeSelectCode = '2'
}) => {
  const { Option, SingleValue } = components;
  const IconOption = (props) => {
    return (
      <Option {...props}>
        {
          props.data.value && JSON.parse(props.data.value).phone_code && (
            <>{JSON.parse(props.data.value).phone_code}</>
          )
        }
      </Option>
    )
  };

  const SelectValue = (props) => {
    return (
      <SingleValue {...props}>
        {country && JSON.parse(country).phone_code ? JSON.parse(country).phone_code : props.data.label}
      </SingleValue>
    )
  }

  return (
    <CCol lg={colSize} className={className}>
      <CFormLabel>
        {inputLabel}
      </CFormLabel>
      <CInputGroup>
        <CDropdown variant="input-group">
          <FormSelectInput 
            id='phone_country'
            name='phone_country'
            colSize={colSizeSelectCode}
            className='me-3'
            selectOptions={countryOptions}
            value={country && Object.keys(country).length > 0 ? {
              label: JSON.parse(country).name,
              value: JSON.parse(country).id,
              icon: JSON.parse(country).icon
            } : null}
            handleSelectInput={handlePhoneCountry}
            invalid={errors?.country_id}
            disabled={disabled}
            isShowLabel={false}
            isShowInvalidErr={false}
            placeholder='Country'
            componentSelect={{ Option: IconOption, SingleValue: SelectValue }}
            isClearable={false}
          />
        </CDropdown>
        <CFormInput
          id="phone_number"
          name="phone_number"
          placeholder={placeholder}
          type='text'
          invalid={errors?.phone_number}
          onChange={(e) => handlePhoneNumber(e)}
          value={value.phone_number}
          disabled={disabled}
        />
      </CInputGroup>
      {
        (errors?.phone_number || errors?.country_id) && (
          <span className='error-text-field'>{errors.phone_number || errors.country_id}</span>
        )
      }
    </CCol>
  )
}

export default FormPhoneNumber